import { render, staticRenderFns } from "./task_stuck.vue?vue&type=template&id=4597b2e0"
import script from "./task_stuck.vue?vue&type=script&lang=js"
export * from "./task_stuck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports